// 接口域名的管理

const base = {    
    UPLOADURL: "http://124.226.194.221:38082/msa-file/api/file", // 文件上传地址

    
    spurl: 'http://127.0.0.1:8888/api/private/v1',
    
}

export default base;